<script>
	import listBase from '@_system/components/base/list.vue'
	export default {
		extends: listBase,
		name: 'pendingexchange',
		props: {

		},
		data() {
			return {
				moduleName: 'pendingexchange',
				windowName: '待处理售后单',
				windowType: 'modal',
				pagerConfig: {
					enabled: false,
					autoHidden: false,
					border: true,
					size: 'mini',
					perfect: false,
					currentPage: 1,
					pageSize: 20,
					pageSizes: [10, 20, 50, 100, 200, 500],
				},
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			apply(row){
				this.$api.flow.getSingleFlowTemplate(20).then((e) => {
					if (e) {
						let res = this.$router.resolve({
							name: 'add',
							query: {
								name: 'paymentapplication',								
								id: 0,
								controlltype: 1,
								windowName: '售后付款申请',
								extra: JSON.stringify({
									billCode: row.exchange_no,
									componentname:'exchangepaymentform',
									// receiveaccount:row.receive_account,
								}),
								isflow: 1,
								flowid: 20
							}
						})
						if (this.device != 'pc') {
							this.$router.push(res.href.replace(/#/g, ''))
						} else {
							let win = window.open(res.href, this.moduleName + "add",
								this.$store.state.system.windowConfig)
							win.onload = () => {
								console.log(this.moduleName + 'form open')
							}
						}
							
					}
				})
			},
			// list(page,updateForm,other) {				
			// 	return new Promise((resolve,reject) => {
			// 		this.$api[this.moduleName].list({
			// 			...page,
			// 			...updateForm,
			// 			...other,
			// 			...this.foreingKey,
			// 		}).then(() => {
			// 			resolve([])
			// 		}, () => {
			// 			reject()
			// 		})
			// 	})
			// },
			initList() {
				this.initOption()
			},
			getColumns() {
				return [{
						type: 'seq',
						title: '序号',
						width:50
					},{
						field: 'exchange_no',
						title: '单据编号',
						width:100
					},{
						field: 'exchange_type',
						title: '售后类型',
						width:100,
						formatter:({cellValue})=>{
							let map = {
								"0":"退货",
								"1":"补发",
								"2":"换货",
								"3":"其他",
								"4":"仅退款",
								"5":"维修",
							}
							return map[cellValue]
						}
					},
					{
						field: 'amount',
						title: '退款金额',
						width:100
					},
					{
						field: 'create_user',
						title: '申请人',
						width:100,
						sortable:true,
					},
					{
						field: 'receive_account',
						title: '客户收款账户 格式:【账户|名称】',
						width:200
					},	
					{
						field: 'reason_detail',
						title: '问题详情',
						width:100
					},
														
					{
						field: 'tp_buyer',
						title: '买家ID',
						width:100
					},																							
					{
						field: 'showName',
						title: '店铺',
						width:100
					},
					{
						field: 'trade_no',
						title: '系统订单号',
						width:100,
						slots:{
							default:({row})=>{
								return [<el-link type="primary" style="font-size:12px;" onClick={()=>{this.tradedetail(row)}} >{row.trade_no}</el-link>]
							}
						}
						
					},
					{
						field: 'reason_uid',
						title: '线上订单号',
						width:100
					},
					{
						field: 'file',
						title: '凭证',
						width:200,
						slots:{
							default:({row})=>{
								let file = []
								let arr = []
								for(let i=1;i<4;i++){
									if(row['pic'+i]){
										file.push(row['pic'+i])
									}
								}
								for(let i=1;i<4;i++){
									if(row['pic'+i]){
										arr.push(  <el-image style="width: 30px; height: 30px" src={row['pic'+i]} preview-src-list={file}></el-image>)
									}
								}
								return arr
							}
						}
					},
					{
						field: 'paymentapplicationcode',
						title: '付款申请编码',
						fixed:"right",
						width:120
					},
					{
						field: 'reslut',
						title: '错误描述',
						fixed:"right",
						width:100
					},
					{
						field: 'paystatus',
						title: '交易状态',
						width:100,
						fixed:"right",
						slots: {
							default: ({row}) => {
								if(row.paystatus == 0){
									return '成功'
								}
							}
						}
					},
					{
						field: 'auditorstaffid',
						title: '审核状态',
						width:100,
						fixed:"right",
						slots: {
							default: ({row}) => {
								if(row.auditorstaffid){
									return <span style="color:#67C23A" >已审核</span>
								}else{
									return <span style="color:#F56C6C" >未审核</span>
								}
								
							}
						}
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 120,
						slots: {
							default: ({row}) => {
								return [<el-button type = "text" size = "mini" onClick = {() => {this.apply(row)}}>售后付款申请</el-button>]
							}
						}
					}
				]
			},
			getForm() {
				return {
					//enabled:false,
					titleWidth: '80',
					titleAlign: 'center',
					items: [{
						field: 'exchange_no',
						title: '单据编号',
						itemRender: {
							name: '$input'
						}
					}, {
						itemRender: {
							name: '$buttons',
							children: [{
								props: {
									type: 'submit',
									content: '查询',
									status: 'primary'
								}
							}, {
								props: {
									type: 'reset',
									content: '重置'
								}
							}]
						}
					}],
					span: 4
				}
			},
			beforeCreateGrid(formConfig, columns, gridOptions) {
				gridOptions.toolbarConfig = {
					size: 'mini',
					perfect: false,
					buttons: [],
					// buttons: [{
					// 	name: '添加',
					// 	status: 'primary',
					// 	code: 'add'
					// }],
					customConfig: {
						storage: true
					},
					custom: true,
					refresh: true,
					tools: this.tools
				}
			},
			toolbarButtonClickEvent(e) {
				this[e.code]()
			},
			tradedetail(row){
				this.loading = true
				this.$api.pendingexchange.getTradeDetail({
					tp_tid:row.tp_tid,
					tradeUids:row.salercpt_uid,
					shopUid:row.sys_shop,
				}).then((res)=>{
					this.loading = false
					if(res){
						this.$alert('买家付款：'+ this.$Lodash.sumBy(res, item=>parseFloat(item.tp_payment)))
						//tp_payment
					}else{
						this.$message.error('未查询到订单')
					}
				},()=>{
					this.loading = false
				})
				
			}
			// add(){
			// 	alert(123)
			// },
		},
		components: {

		}
	}
</script>